import { cfg } from '../config/config';
import { axiosInstance } from './request';

export const getNotesUrl = () =>
  axiosInstance.get<{ url: string; actionUrl: string }>(
    `${cfg.apiUrl}/api/notes`
  );
